// extracted by mini-css-extract-plugin
module.exports = {"root":"Figure_root__wZn3l","left":"Figure_left__3HyIx"};